import logo from './images/logoColor.svg';
import Logo from './images/logoColor.svg?react';
import IconEmployees from './images/iconEmployees.svg?react';
import IconHome from './images/iconHome.svg?react';
import IconHelp from './images/iconHelp.svg?react';
import IconLocations from './images/iconLocations.svg?react';
import IconParts from './images/iconParts.svg?react';
import IconPayouts from './images/iconPayouts.svg?react';
import IconPurchaseInventory from './images/iconPurchaseInventory.svg?react';
import IconReports from './images/iconReports.svg?react';
import IconSelling from './images/iconSelling.svg?react';
import IconSignout from './images/iconSignout.svg?react';
import IconVehicles from './images/iconVehicles.svg?react';
import bid_1 from './images/bid_1.jpg';
import bid_2 from './images/bid_2.jpg';
import bid_3 from './images/bid_3.jpg';
import bid_4 from './images/bid_4.jpg';
import bid_5 from './images/bid_5.jpg';
import bid_6 from './images/bid_6.jpg';
import bid_7 from './images/bid_7.jpg';
import starOn from './images/starOn.svg?react';
import starOff from './images/starOff.svg?react';
import iconTrash from './images/iconTrash.svg?react';
import iconTrendUp from './images/iconTrendUp.svg?react';
import iconBadgeCheck from './images/iconBadgeCheck.svg?react';
import iconBadgeUncheck from './images/iconBadgeUncheck.svg?react';
import iconClipboardCheck from './images/iconClipboardCheck.svg?react';
import iconDocumentText from './images/iconDocumentText.svg?react';
import iconKey from './images/iconKey.svg?react';
import iconPhotograph from './images/iconPhotograph.svg?react';
import iconSearchCircle from './images/iconSearchCircle.svg?react';
import iconTruck from './images/iconTruck.svg?react';
import iconChevronRight from './images/iconChevronRight.svg?react';
import iconTaskComplete from './images/iconTaskComplete.svg?react';
import iconArrowLeft from './images/iconArrowLeft.svg?react';
import iconEye from './images/iconEye.svg?react';
import iconUploadFile from './images/iconUploadFile.svg?react';
import iconQuestionMark from './images/iconQuestionMark.svg?react';
import iconCash from './images/iconCash.svg?react';
import iconMenu from './images/iconMenu.svg?react';
import iconUser from './images/iconUser.svg?react';
import iconArrowDown from './images/iconArrowDown.svg?react';
import homeIconStarHalf from './images/homeIconStarHalf.svg?react';
import homeIconCheckRound from './images/homeIconCheckRound.svg?react';
import homeIconCircular from './images/homeIconCircular.svg?react';
import homeIconMoney from './images/homeIconMoney.svg?react';
import homeIconPhone from './images/homeIconPhone.svg?react';
import homeIconStar from './images/homeIconStar.svg?react';
import homeIconSearch from './images/homeIconSearch.svg?react';
import iconFilterBus from './images/iconFilterBus.svg?react';
import iconFilterCar from './images/iconFilterCar.svg?react';
import iconFilterCoupe from './images/iconFilterCoupe.svg?react';
import iconFilterExotic from './images/iconFilterExotic.svg?react';
import iconFilterSUV from './images/iconFilterSUV.svg?react';
import iconFilterTruck from './images/iconFilterTruck.svg?react';
import iconFilterVan from './images/iconFilterVan.svg?react';
import iconHeart from './images/iconHeart.svg?react';
import iconHeartFull from './images/iconHeartFull.svg?react';
import iconTea from './images/iconTea.svg?react';
import iconHands from './images/iconHands.svg?react';
import iconLock from './images/iconLock.svg?react';
import iconMoney from './images/iconMoney.svg?react';
import iconExcl from './images/iconExcl.svg?react';
import iconHandPlant from './images/iconHandPlant.svg?react';
import iconHandshake from './images/iconHandshake.svg?react';
import iconLike from './images/iconLike.svg?react';
import iconX from './images/iconX.svg?react';
import iconCurrency from './images/iconCurrency.svg?react';
import iconFb from './images/iconFb.svg?react';
import iconGlobe from './images/iconGlobe.svg?react';
import iconIg from './images/iconIg.svg?react';
import iconTikTok from './images/iconTikTok.svg?react';
import iconLn from './images/iconLn.svg?react';
import iconBlueCheckCircle from './images/iconBlueCheckCircle.svg?react';
import iconCloudUpload from './images/iconCloudUpload.svg?react';
import iconGraphUp from './images/iconGraphUp.svg?react';
import iconMedalRibbonsStar from './images/iconMedalRibbonsStar.svg?react';
import iconPieChart from './images/iconPieChart.svg?react';
import iconUserRounded from './images/iconUserRounded.svg?react';
import iconWallet from './images/iconWallet.svg?react';
import unknownCar from './images/unknownCar.png';
import iconFileClip from './images/iconFileClip.svg?react';
import iconChevronDown from './images/iconChevronDown.svg?react';
import imgPlaceholderLow from './images/imgPlaceholderLow.gif';

const AppImages = {
    'logo': logo,
    'Logo': Logo,
    'IconEmployees': IconEmployees,
    'IconHome': IconHome,
    'IconHelp': IconHelp,
    'IconLocations': IconLocations,
    'IconParts': IconParts,
    'IconPayouts': IconPayouts,
    'IconPurchaseInventory': IconPurchaseInventory,
    'IconReports': IconReports,
    'IconSelling': IconSelling,
    'IconSignout': IconSignout,
    'IconVehicles': IconVehicles,
    'bid_1': bid_1,
    'bid_2': bid_2,
    'bid_3': bid_3,
    'bid_4': bid_4,
    'bid_5': bid_5,
    'bid_6': bid_6,
    'bid_7': bid_7,
    'starOn': starOn,
    'starOff': starOff,
    'iconTrash': iconTrash,
    'iconBadgeCheck': iconBadgeCheck,
    'iconBadgeUncheck': iconBadgeUncheck,
    'iconDocumentText': iconDocumentText,
    'iconKey': iconKey,
    'iconPhotograph': iconPhotograph,
    'iconSearchCircle': iconSearchCircle,
    'iconTruck': iconTruck,
    'iconClipboardCheck': iconClipboardCheck,
    'iconChevronRight': iconChevronRight,
    'iconTaskComplete': iconTaskComplete,
    'iconArrowLeft': iconArrowLeft,
    'iconEye': iconEye,
    'iconUploadFile': iconUploadFile,
    'iconQuestionMark': iconQuestionMark,
    'iconTrendUp': iconTrendUp,
    'iconCash': iconCash,
    'iconMenu': iconMenu,
    'iconUser': iconUser,
    'iconArrowDown': iconArrowDown,
    'homeIconCheckRound': homeIconCheckRound,
    'homeIconCircular': homeIconCircular,
    'homeIconMoney': homeIconMoney,
    'homeIconPhone': homeIconPhone,
    'homeIconStar': homeIconStar,
    'homeIconStarHalf': homeIconStarHalf,
    'homeIconSearch': homeIconSearch,
    'iconFilterBus': iconFilterBus,
    'iconFilterCar': iconFilterCar,
    'iconFilterCoupe': iconFilterCoupe,
    'iconFilterExotic': iconFilterExotic,
    'iconFilterSUV': iconFilterSUV,
    'iconFilterTruck': iconFilterTruck,
    'iconFilterVan': iconFilterVan,
    'iconHeart': iconHeart,
    'iconHeartFull': iconHeartFull,
    'iconTea': iconTea,
    'iconHands': iconHands,
    'iconLock': iconLock,
    'iconMoney': iconMoney,
    'iconExcl': iconExcl,
    'iconHandPlant': iconHandPlant,
    'iconHandshake': iconHandshake,
    'iconLike': iconLike,
    'iconX': iconX,
    'iconCurrency': iconCurrency,
    'iconFb': iconFb,
    'iconGlobe': iconGlobe,
    'iconIg': iconIg,
    'iconTikTok': iconTikTok,
    'iconLn': iconLn,
    'iconBlueCheckCircle': iconBlueCheckCircle,
    'iconCloudUpload': iconCloudUpload,
    'iconGraphUp': iconGraphUp,
    'iconMedalRibbonsStar': iconMedalRibbonsStar,
    'iconPieChart': iconPieChart,
    'iconUserRounded': iconUserRounded,
    'iconWallet': iconWallet,
    'unknownCar': unknownCar,
    'iconFileClip': iconFileClip,
    'iconChevronDown': iconChevronDown,
    'imgPlaceholderLow': imgPlaceholderLow,
}

export default AppImages;
